"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorSelector = exports.ButtonWidgetStylePanel = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var StyleShortCutContainer_1 = __importDefault(require("Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var WithColorFilterSubscription_1 = __importDefault(require("DreamCoat/WithColorFilterSubscription/WithColorFilterSubscription"));
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ButtonWidgetStylePanel = (function (_super) {
    __extends(ButtonWidgetStylePanel, _super);
    function ButtonWidgetStylePanel() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.handleKeyPress = function (event) {
            if (event.key === "Enter" || event.key === "Tab") {
                event.preventDefault();
                event.stopPropagation();
                event.target.blur();
            }
        };
        _this.handleColorChange = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var button = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("button"));
            button.color = {
                themeIndex: color.themeIndex,
                abs: color.value,
            };
            button.textColor = (0, ColorUtils_1.shouldUseDarkText)(color.value) ? "dark" : "light";
            blockStyleStore.setElementStyle("button", button);
        };
        _this.handleSizeChange = function (size) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var button = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("button"));
            button.size = size;
            blockStyleStore.setElementStyle("button", button);
        };
        _this.handleRoundnessChange = function (roundness) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var button = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("button"));
            button.roundness = roundness;
            blockStyleStore.setElementStyle("button", button);
        };
        return _this;
    }
    ButtonWidgetStylePanel.prototype.render = function () {
        var _a = this.props, filteredColors = _a.filteredColors, blockStyleStore = _a.blockStore.blockStyleStore;
        var buttonStyle = blockStyleStore.getElementStyle("button");
        return (react_1.default.createElement(StyleShortCutContainer_1.default, { dark: true },
            react_1.default.createElement("div", { className: "style-shortcut__header" }, "Button style"),
            react_1.default.createElement("div", { onKeyDown: this.handleKeyPress },
                react_1.default.createElement(exports.ColorSelector, { colors: filteredColors, handleColorChange: this.handleColorChange, label: "Button Color", selectedColor: buttonStyle.color }),
                react_1.default.createElement(ButtonSize, { currentSize: buttonStyle.size, selectSize: this.handleSizeChange }),
                react_1.default.createElement(kaleidoscope_1.SliderInput, { handleValueChange: this.handleRoundnessChange, theme: kaleidoscope_1.SliderTheme.Dark, label: "Roundness", unit: "px", initialInputValue: buttonStyle.roundness, maximum: 50 }))));
    };
    ButtonWidgetStylePanel = __decorate([
        mobx_react_1.observer
    ], ButtonWidgetStylePanel);
    return ButtonWidgetStylePanel;
}(react_1.default.Component));
exports.ButtonWidgetStylePanel = ButtonWidgetStylePanel;
var ColorSelector = function (_a) {
    var colors = _a.colors, label = _a.label, handleColorChange = _a.handleColorChange, selectedColor = _a.selectedColor;
    return (react_1.default.createElement("div", { className: "style-shortcut__section" },
        react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, label),
        react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
            react_1.default.createElement(ColorPalette_1.default, { presetColors: colors, onColorChange: handleColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(selectedColor), colors), type: "content" }))));
};
exports.ColorSelector = ColorSelector;
var ButtonSize = function (_a) {
    var currentSize = _a.currentSize, selectSize = _a.selectSize;
    var buttonSizeOptions = [
        {
            label: "S",
            value: BlockStyleTypes_1.ButtonWidgetSize.Small,
        },
        {
            label: "M",
            value: BlockStyleTypes_1.ButtonWidgetSize.Medium,
        },
        {
            label: "L",
            value: BlockStyleTypes_1.ButtonWidgetSize.Large,
        },
    ];
    return (react_1.default.createElement("div", { className: "style-shortcut__section" },
        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: "Button size", size: kaleidoscope_1.SegmentedControlSize.Medium, options: buttonSizeOptions, selectedValue: currentSize, onClickHandler: selectSize })));
};
exports.default = (0, WithColorFilterSubscription_1.default)(ButtonWidgetStylePanel);
